import { ChatTranslations } from '@/assets/locales/util/chat/chat.translations.pl.ts';

export const chatTranslations: ChatTranslations = {
  error: {
    messageFailed: 'An error occurred while processing the message.',
    noChatId:
      'The chat has not been initialized. Please refresh the page and try again. If the problem persists, contact the administrator.',
    requestTimeout: 'The request processing has timed out.',
  },
};
